import { RootState } from '@app/redux/store';

export const getListMark = (state: RootState) => state.autoParams.listMark;
export const getListModel = (state: RootState) => state.autoParams.listModel;
export const getListYear = (state: RootState) => state.autoParams.listYear;
export const getListModification = (state: RootState) => state.autoParams.listModification;
